import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
// import vendors from '../../constants/vendors';
import { useParams } from 'react-router-dom';
import { useFormFields } from '../../libs/hooksLib';
import { logError } from '../../libs/errorLib';
import { Alert } from 'reactstrap';
import { vendorIsReadOnlyCheck } from '../../helpers/rbac';

import { VendorsContext } from '../../context/VendorsContext';
import { DashboardContext } from '../../context/DashboardContext';

// config forms
import ConfigFormAzure from '../managed-product/config-forms/ConfigFormAzure';
import ConfigFormAwsConfig from '../managed-product/config-forms/ConfigFormAwsConfig';
import ConfigFormAwsResilienceHub from '../managed-product/config-forms/ConfigFormAwsResilienceHub';
import ConfigFormAwsSecurityHub from '../managed-product/config-forms/ConfigFormAwsSecurityHub';
import ConfigFormRedHat from '../managed-product/config-forms/ConfigFormRedHat';
// import ConfigFormHPE from '../managed-product/config-forms/ConfigFormHPE';
import ConfigFormFortinet from '../managed-product/config-forms/ConfigFormFortinet';
import ConfigFormCisco from '../managed-product/config-forms/ConfigFormCisco';
import ConfigFormServiceNow from '../managed-product/config-forms/ConfigFormServiceNow';
import ConfigFormMSFT365 from '../managed-product/config-forms/ConfigFormMSFT365';
import ConfigFormMongoDB from '../managed-product/config-forms/ConfigFormMongoDB';
import ConfigFormVmware from '../managed-product/config-forms/ConfigFormVmware';
import ConfigFormVeeam from '../managed-product/config-forms/ConfigFormVeeam';
import ConfigFormNetApp from '../managed-product/config-forms/ConfigFormNetApp';
import ConfigFormMSFT from '../managed-product/config-forms/ConfigFormMSFT';
import ConfigFormMSFTAccess from '../managed-product/config-forms/ConfigFormMSFTAccess';
import ConfigFormMSFTSqlServer from '../managed-product/config-forms/ConfigFormMSFTSqlServer';
import ConfigFormMSFTWindowsServer from '../managed-product/config-forms/ConfigFormMSFTWindowsServer';
import ConfigFormAWS from '../managed-product/config-forms/ConfigFormAWS';
import ConfigFormF5 from '../managed-product/config-forms/ConfigFormF5';
import ConfigFormCitrixNetScaler from '../managed-product/config-forms/ConfigFormCitrixNetScaler';
import ConfigFormCitrixXenDesktop from '../managed-product/config-forms/ConfigFormCitrixXenDesktop';
import ConfigFormPaloAlto from '../managed-product/config-forms/ConfigFormPaloAlto';
import ConfigFormPostgreSQL from '../managed-product/config-forms/ConfigFormPostgreSQL';
import ConfigFormLogicMonitor from '../managed-product/config-forms/ConfigFormLogicMonitor';
import Heading from '../common/Heading';
import BZAPIService from '../../services/BZAPIService';

import { isEmpty } from 'lodash';
import SETTINGS from '../../constants/settings';
import SERVICENOW from '../../constants/servicenow';

const managedProductForms = {
  aws: ConfigFormAWS,
  awsconfig: ConfigFormAwsConfig,
  awsreshub: ConfigFormAwsResilienceHub,
  awssechub: ConfigFormAwsSecurityHub,
  azure: ConfigFormAzure,
  rh: ConfigFormRedHat,
  // hpe: ConfigFormHPE,
  f5: ConfigFormF5,
  ctrxns: ConfigFormCitrixNetScaler,
  ctrxxen: ConfigFormCitrixXenDesktop,
  msft: ConfigFormMSFT,
  msft365: ConfigFormMSFT365,
  msftaccess: ConfigFormMSFTAccess,
  msftsql: ConfigFormMSFTSqlServer,
  msftserver: ConfigFormMSFTWindowsServer,
  cisco: ConfigFormCisco,
  sn: ConfigFormServiceNow,
  mongodb: ConfigFormMongoDB,
  vmware: ConfigFormVmware,
  veeam: ConfigFormVeeam,
  logmon: ConfigFormLogicMonitor,
  netapp: ConfigFormNetApp,
  fortinet: ConfigFormFortinet,
  paloalto: ConfigFormPaloAlto,
  postgre: ConfigFormPostgreSQL
};

export default function ManagedProductConfig() {
  const { vendorId } = useParams();
  const [vendor, setVendor] = useState();
  const [loading, setLoading] = useState(true);
  // const [vendor, setVendor] = useState(null);
  const [isReadOnly, setIsReadOnly] = useState(true);
  const [allRequired, setAllRequired] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [settings, setSettings] = useState(null);
  const [snCompanySysIdOptions, setSnCompanySysIdOptions] = useState({});
  const [snCompanySysIdErrors, setSnCompanySysIdErrors] = useState(true);
  const [vendorStatuses, setVendorStatuses] = useState([]);
  const [vendorSupportStatus, setVendorSupportStatus] = useState([]);
  const [vendorResolutions, setVendorResolutions] = useState([]);
  const [vendorRiskCategories, setVendorRiskCategories] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [vendorEventScopes, setVendorEventScopes] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [organizationOptions, setOrganizationOptions] = useState([]);
  const [awsOrgHealthEnabled, setAwsOrgHealthEnabled] = useState(false);
  const [subscriptions, setSubscriptions] = useState([]);
  const [subscriptionOptions, setSubscriptionOptions] = useState([]);
  const [vendorBugTypes, setVendorBugTypes] = useState([]);
  const [vendorBugCategories, setVendorBugCategories] = useState([]);
  const [vendorProductBugCategories, setVendorProductBugCategories] = useState([]);
  const [vendorBugServices, setVendorBugServices] = useState([]);
  const [vendorMitigationTypes, setVendorMitigationTypes] = useState([]);
  // const [vendorEventLevels, setVendorEventLevels] = useState([]);
  const [vendorImpactedRegions, setVendorImpactedRegions] = useState([]);
  const [vendorComplianceStatus, setVendorComplianceStatus] = useState([]);
  // const [supportCasesCount, setCases] = useState(0);
  const [isCve, setIsCve] = useState();
  const [excludedComponents, setExcludedComponents] = useState([]);

  const [autoClose, setAutoClose] = useState(false);

  const [bugRisk, setBugRisk] = useState([]);

  const [msSqlAgree, setMsSqlAgree] = useState(false);

  const [services, setServices] = useState([]);
  const [isServiceActive, setIsServiceActive] = useState(0);
  const [activeVendors, setActiveVendors] = useState([]);
  const [bugs, setBugs] = useState({});
  const [priorityStats, setPriorityStats] = useState({});
  const [snIntegrationCheck, setSnIntegrationCheck] = useState(false);
  const [priorityMaps, setPriorityMaps] = useState([]);
  const [snCompanySysId, setSnCompanySysId] = useState({});
  const [isConfigured, setIsConfigured] = useState(true);

  const [keywords, setKeywords] = useState([]);
  const [searchFields, setSearchFields] = useState([]);
  const snPriorityOptions = SERVICENOW.SN_PRIORITY_OPTIONS;
  const [enableChatGptPriority, setEnableChatGptPriority] = useState(false);

  const [bugsDateBack, setBugsDateBack] = useState('');

  const [syncOnly, setSyncOnly] = useState(false);

  // eslint-disable-next-line
  const [vendors, setVendors] = useContext(VendorsContext);
  // eslint-disable-next-line
  const [dashboard, setDashboard] = useContext(DashboardContext);

  const [fields, handleFieldChange] = useFormFields({
    secretId: '',
    refreshToken: '',
    serviceSecretId: '',
    // serviceClientId: '',
    // serviceClientSecret: '',
    supportSecretId: '',
    supportClientId: '',
    supportClientSecret: '',
    // bugsDateBack: '',
    snCompanySysId: '',
    snAffectedCIQuery: '',
    cloudAppsUser: '',
    cloudAppsPass: '',
    cloudLoginId: '',
    username: '',
    password: '',
    mfaSecret: '',
    awsApiHealthApiRoleArn: '',
    clientSecret: '',
    tenantId: '',
    appId: ''
  });

  const bugOptions = [
    { value: 'bugsLastWeek', label: 'Last 7 Days' },
    { value: 'bugsLastMonth', label: 'Last 30 Days' },
    { value: 'bugsLastQuarter', label: 'Last 90 Days' }
  ];

  const [selectedBugOption, setSelectedBugOption] = useState(bugOptions[0]);

  function buildVendorStat(dataSet, colors) {
    const vendorPriorityStats = {};
    vendors?.map(v => {
      return (vendorPriorityStats[v.id] = []);
    });

    dataSet?.map((bugPriority, id) => {
      if (!vendorPriorityStats[bugPriority.vendorId]) vendorPriorityStats[bugPriority.vendorId] = [];
      const colorIndex = vendorPriorityStats[bugPriority.vendorId].length;

      const vendorPriorityStat = {
        id,
        value: bugPriority.priorityCount,
        name: bugPriority.priority,
        color: bugPriority.priority === 'Unspecified' ? '#90919a' : colors[colorIndex]
      };
      return vendorPriorityStats[bugPriority.vendorId].push(vendorPriorityStat);
    });

    // If no data, add 0 data for graph
    Object.keys(vendorPriorityStats).map((key, index) => {
      if (!vendorPriorityStats[key].length) {
        const vendorPriorityStat = {
          id: `z${index}`,
          value: 0.01, // Avoid NaN on graph and don't divide by 0
          name: 'No Bugs',
          color: '#d8d4ce'
        };
        vendorPriorityStats[key].push(vendorPriorityStat);
      }
      return vendorPriorityStats;
    });
    return vendorPriorityStats;
  }

  async function onLoad(v) {
    try {
      const settingsPromise = BZAPIService.getSetting(vendorId);
      const myUserPermissionsPromise = BZAPIService.getMyUserPermissions();
      const serviceStatusPromise = BZAPIService.getStatus(vendorId);
      const snIntegrationPromise = BZAPIService.getSetting(SETTINGS.SERVICE_NOW);
      const companiesPromise = BZAPIService.integrationServiceNowCompanies();

      const [settings, myUserPermissionsData, serviceStatus, snIntegration, companies] = await Promise.all([
        settingsPromise,
        myUserPermissionsPromise,
        serviceStatusPromise,
        snIntegrationPromise,
        companiesPromise
      ]);
      setSettings(settings);
      console.log('vendorId', vendorId, settings);
      // Permission check
      // iterate permissions and check if vendor is read only.
      setIsReadOnly(vendorIsReadOnlyCheck(vendorId, myUserPermissionsData));
      setIsServiceActive(serviceStatus?.data?.enabled);
      isEmpty(snIntegration) ? setSnIntegrationCheck(false) : setSnIntegrationCheck(true);

      if (!companies || isEmpty(companies)) {
        setSnCompanySysIdErrors(true);
      } else {
        const snCompanySysId = companies?.companies
          ? companies.companies.find(o => o.value === settings?.snCompanySysId)
          : {};
        setSnCompanySysId(snCompanySysId);
        setSnCompanySysIdErrors(false);
        setSnCompanySysIdOptions(companies);
      }

      // Clear up creds
      fields.username = '';
      fields.password = '';
      fields.mfaSecret = '';
      fields.tenantId = '';
      fields.appId = '';
      fields.clientSecret = '';
      fields.secretId = '';

      setBugsDateBack(settings?.bugsDateBack || '');
      fields.snCompanySysId = settings?.snCompanySysId || '';
      fields.snAffectedCIQuery = settings?.snAffectedCIQuery || '';
      fields.secretId = settings?.secretId;
      fields.serviceSecretId = settings?.serviceSecretId;
      fields.supportSecretId = settings?.supportSecretId;
      fields.snAffectedCIQuery = settings?.snAffectedCIQuery || '';
      fields.cloudLoginId = settings?.cloudLoginId || '';

      // if bug risk settings, compare length, add new defaults if any
      if (settings?.bugRiskScore?.length) {
        const settingsBugs = settings?.bugRiskScore;
        const settingsLength = settings?.bugRiskScore?.length;
        const defaultsLength = v?.vendorData?.bugRiskScore?.length;
        if (defaultsLength > settingsLength) {
          const newDefaults = v?.vendorData?.bugRiskScore?.slice(settingsLength);
          setBugRisk(settingsBugs.concat(newDefaults));
        } else {
          setBugRisk(settingsBugs);
        }
      }
      // If no bug risk score settings, set defaults
      if (!settings?.bugRiskScore?.length) setBugRisk(v?.vendorData?.bugRiskScore);

      if (settings?.vendorComplianceStatus) setVendorComplianceStatus(settings.vendorComplianceStatus);
      if (settings?.accountOrgs) setOrganizations(settings.accountOrgs);
      if (settings?.awsOrgAccounts) setOrganizations(settings.awsOrgAccounts);
      if (settings?.awsOrgHealthEnabled) setOrganizations(settings.awsOrgHealthEnabled);
      if (v?.vendorData?.accountOrgs) setOrganizationOptions(v.vendorData.accountOrgs);
      if (settings?.subscriptions) setSubscriptions(settings?.subscriptions);
      if (v?.vendorData?.subscriptions) setSubscriptionOptions(v.vendorData.subscriptions);
      if (settings?.activeIqCustomers) setCustomers(settings?.activeIqCustomers);
      if (settings?.autoClose) setAutoClose(settings?.autoClose);
      if (settings?.autoCloseBugTicket) setAutoClose(settings?.autoCloseBugTicket);
      if (settings?.disclaimers?.msftSqlAiDisclaimer?.agreementSigned)
        setMsSqlAgree(settings?.disclaimers?.msftSqlAiDisclaimer?.agreementSigned);

      setVendorResolutions(settings?.vendorBugResolutions);
      if (vendorId === 'postgre') {
        setVendorStatuses(settings?.vendorStatuses?.length > 1 ? settings?.vendorStatuses : v.vendorData.statuses);
      } else {
        setVendorStatuses(settings?.vendorStatuses);
      }
      if (settings?.vendorSupportStatus) {
        setVendorSupportStatus(settings?.vendorSupportStatus);
      }

      setVendorEventScopes(settings?.vendorEventScopes);
      setVendorBugTypes(settings?.vendorBugTypes);
      setVendorBugCategories(settings?.vendorBugCategories);
      setVendorBugServices(settings?.vendorBugServices);
      setVendorProductBugCategories(settings?.vendorBugModules);
      // setVendorEventLevels(settings?.vendorEventLevels);
      setVendorImpactedRegions(settings?.vendorImpactedRegions);
      setVendorRiskCategories(settings?.vendorRiskCategories);
      setVendorMitigationTypes(settings?.vendorMitigationTypes);
      setEnableChatGptPriority(
        settings?.enableChatGptPriority === 1
          ? true
          : settings?.disclaimers?.msftSqlAiDisclaimer?.agreementSigned !== undefined
          ? settings?.disclaimers?.msftSqlAiDisclaimer?.agreementSigned
          : false
      );

      setIsCve(
        settings === undefined || settings?.filterCVEs === undefined ? v?.vendorData?.filterCVEs : settings?.filterCVEs
      );

      settings?.excludedBugComponents
        ? setExcludedComponents(settings?.excludedBugComponents)
        : setExcludedComponents([]);

      // setIncludedComponents(defaults.vendorData.vendorBugComponents);

      if (v?.vendorData?.searchFields) {
        setSearchFields(v?.vendorData?.searchFields);
      } else {
        setSearchFields([]);
      }
      settings?.excludedKws ? setKeywords(settings?.excludedKws) : setKeywords([]);
      if (settings?.searchFields?.length) {
        setSearchFields(settings?.searchFields);
      }

      const priorityMaps = settings?.vendorPriorities?.map(priority => {
        const result = {
          vendorPriority: v?.vendorData?.priorities?.find(e => e.value === priority.value),
          snPriority: snPriorityOptions?.find(e => e.value === priority.snPriority)
        };
        return result;
      });
      setPriorityMaps(priorityMaps);

      const service = dashboard?.services?.filter(service => {
        return service.vendorId === vendorId ? service : null;
      });
      setIsConfigured(
        service?.length && service[0]?.status === 'NOT CONFIGURED'
          ? false
          : service?.length && service[0]?.status === 'OPERATIONAL'
          ? true
          : true
      );
      setSyncOnly(
        service?.length && service[0]?.status === 'NOT CONFIGURED'
          ? true
          : service?.length && service[0]?.status === 'OPERATIONAL'
          ? false
          : false
      );
      setServices(dashboard?.services);

      const activeVendors = vendors?.filter(vendor => v.active);
      setActiveVendors(activeVendors);
      // Setup vendor priority stats
      const colors = [
        '#ff475f',
        '#000000',
        '#961ca2',
        '#35bc8e',
        '#90919a',
        '#c1bdb7',
        '#B54E34',
        '#253544',
        '#48384B',
        '#816577',
        '#445A57',
        '#617E71',
        '#829A92',
        '#567387',
        '#8096A8',
        '#816477'
      ];
      const bugsLastWeek = buildVendorStat(dashboard?.bugsLastWeek, colors);
      const bugsLastMonth = buildVendorStat(dashboard?.bugsLastMonth, colors);
      const bugsLastQuarter = buildVendorStat(dashboard?.bugsLastQuarter, colors);
      const bugs = {
        bugsLastWeek,
        bugsLastMonth,
        bugsLastQuarter
      };
      setPriorityStats(bugsLastWeek);
      setBugs(bugs);
      setLoading(false);
    } catch (e) {
      logError(e);
      console.log(e);
      setLoading(false);
    }
  }

  useEffect(() => {
    if (vendors?.length) {
      const v = vendors?.filter(v => v.id === vendorId);
      setVendor(v[0]);
      console.log('setVendor', v[0]);
      setPriorityMaps([]);
      // setLoading(true);
      if (v?.length) onLoad(v[0]);
    }
    setAllRequired(false);
    setIsUpdated(false);
    // eslint-disable-next-line
  }, [vendorId, vendors]);

  return (
    <>
      <Heading
        title={`${vendor?.name?.replace('Systems', 'Networks')} Configuration`}
        subtitle={`Specify configuration details`}
        className="mb-4 mt-3"
        icon="cog"
        loading={loading}
      />
      {isReadOnly && !loading && snIntegrationCheck ? (
        <Alert color="info">Note: Your user only has read-only access. You will not be able to save any updates.</Alert>
      ) : (
        <></>
      )}

      {React.createElement(managedProductForms[vendorId], {
        loading: loading,
        vendor: vendor,
        isReadOnly: isReadOnly,
        settings: settings ? settings : {},
        vendorLabel: vendor?.name,
        vendorId,
        bugsDateBack: bugsDateBack ? bugsDateBack : '',
        setBugsDateBack: setBugsDateBack,
        vendorPriorityOptions: vendor?.vendorData?.priorities || [],
        vendorStatusOptions: vendor?.vendorData?.statuses || [],
        vendorSupportStatusOptions: vendor?.vendorData?.vendorSupportStatus || [],
        vendorResolutionOptions: vendor?.vendorData?.vendorBugResolutions || [],
        vendorEventScopeOptions: vendor?.vendorData?.eventScopes || [],
        vendorBugCategoryOptions: vendor?.vendorData?.vendorBugCategories ? vendor.vendorData.vendorBugCategories : [],
        vendorBugTypeOptions: vendor?.vendorData?.vendorBugTypes ? vendor.vendorData.vendorBugTypes : [],
        vendorBugServiceOptions: vendor?.vendorData?.vendorBugServices ? vendor.vendorData.vendorBugServices : [],
        vendorComplianceStatus: vendorComplianceStatus ? vendorComplianceStatus : [],
        setVendorComplianceStatus: setVendorComplianceStatus,
        vendorComplianceStatusOptions: vendor?.vendorData?.vendorComplianceStatus
          ? vendor.vendorData?.vendorComplianceStatus
          : [],

        setVendorBugServices: setVendorBugServices,
        vendorBugServices: vendorBugServices ? vendorBugServices : [],
        vendorRiskCategoryOptions: vendor?.vendorData?.vendorRiskCategories
          ? vendor.vendorData.vendorRiskCategories
          : [],
        vendorRiskCategories: vendorRiskCategories ? vendorRiskCategories : [],
        setVendorRiskCategories: setVendorRiskCategories,
        snIntegrationCheck: snIntegrationCheck ? snIntegrationCheck : false,
        services: dashboard?.services ? services : [],
        vendors: activeVendors ? activeVendors : [],
        bugs: bugs ? bugs : {},
        priorityStats: priorityStats ? priorityStats : {},
        setPriorityStats: setPriorityStats,
        bugOptions: bugOptions ? bugOptions : [],
        selectedBugOption: selectedBugOption ? selectedBugOption : {},
        setSelectedBugOption: setSelectedBugOption,
        snCompanySysIdOptions: snCompanySysIdOptions ? snCompanySysIdOptions : {},
        snCompanySysIdErrors: snCompanySysIdErrors ? snCompanySysIdErrors : false,
        setVendorResolutions: setVendorResolutions,
        vendorResolutions: vendorResolutions ? vendorResolutions : [],
        vendorStatuses: vendorStatuses ? vendorStatuses : [],
        vendorSupportStatus: vendorSupportStatus ? vendorSupportStatus : [],
        setVendorStatuses: setVendorStatuses,
        setVendorSupportStatus: setVendorSupportStatus,
        fields: fields ? fields : {},
        handleFieldChange: handleFieldChange,
        snCompanySysId: snCompanySysId ? snCompanySysId : {},
        setSnCompanySysId: setSnCompanySysId,
        keywords: keywords ? keywords : [],
        setKeywords: setKeywords,
        priorityMaps: priorityMaps ? priorityMaps : [],
        setPriorityMaps: setPriorityMaps,
        snPriorityOptions: snPriorityOptions ? snPriorityOptions : [],
        searchFields: searchFields ? searchFields : [],
        setSearchFields: setSearchFields,
        customers: customers ? customers : [],
        setServices: setServices,
        isConfigured: isConfigured ? isConfigured : false,
        setVendors: setActiveVendors,
        setBugs: setBugs,
        buildVendorStat: buildVendorStat,
        setCustomers: setCustomers,
        setVendorEventScopes: setVendorEventScopes,
        vendorEventScopes: vendorEventScopes ? vendorEventScopes : [],
        organizations: organizations ? organizations : [],
        setOrganizations: setOrganizations,
        organizationOptions: organizationOptions,
        setOrganizationOptions: setOrganizationOptions,
        vendorImpactedRegions: vendorImpactedRegions ? vendorImpactedRegions : [],
        setVendorImpactedRegions: setVendorImpactedRegions,
        vendorImpactedRegionOptions: vendor?.vendorData?.vendorImpactedRegions
          ? vendor.vendorData?.vendorImpactedRegions
          : [],
        subscriptions: subscriptions ? subscriptions : [],
        setSubscriptions: setSubscriptions,
        subscriptionOptions: subscriptionOptions ? subscriptionOptions : [],
        setSubscriptionOptions: setSubscriptionOptions,
        vendorBugTypes: vendorBugTypes ? vendorBugTypes : [],
        setVendorBugTypes: setVendorBugTypes,
        setVendorBugCategories: setVendorBugCategories,
        vendorBugCategories: vendorBugCategories ? vendorBugCategories : [],
        vendorProductBugCategories: vendorProductBugCategories ? vendorProductBugCategories : [],
        setVendorProductBugCategories: setVendorProductBugCategories,
        vendorProductBugCategoryOptions:
          vendor?.vendorData?.vendorProductBugCategories && vendor?.vendorData?.vendorProductBugCategories['BIG-IP']
            ? vendor?.vendorData?.vendorProductBugCategories['BIG-IP']
            : vendor?.vendorData?.vendorBugModules
            ? vendor?.vendorData?.vendorBugModules
            : [],
        syncOnly: syncOnly ? syncOnly : false,
        setSyncOnly: setSyncOnly,
        bugRisk: bugRisk,
        setBugRisk: setBugRisk,
        isCve: isCve,
        setIsCve: setIsCve,
        enableChatGptPriority: enableChatGptPriority,
        setEnableChatGptPriority: setEnableChatGptPriority,
        autoClose: autoClose,
        setAutoClose: setAutoClose,
        excludedComponents: excludedComponents,
        setExcludedComponents: setExcludedComponents,
        vendorMitigationTypes: vendorMitigationTypes,
        setVendorMitigationTypes: setVendorMitigationTypes,
        vendorMitigationTypeOptions: vendor?.vendorData?.vendorMitigationTypes,
        msSqlAgree: msSqlAgree,
        setMsSqlAgree: setMsSqlAgree,
        isServiceActive: isServiceActive,
        setIsServiceActive: setIsServiceActive,
        awsOrgHealthEnabled: awsOrgHealthEnabled,
        setAwsOrgHealthEnabled: setAwsOrgHealthEnabled,
        allRequired,
        setAllRequired,
        isUpdated,
        setIsUpdated
      })}
    </>
  );
}

ManagedProductConfig.propTypes = {
  forms: PropTypes.func,
  vendorLabel: PropTypes.string,
  vendorId: PropTypes.string
};
